import React, { useState } from 'react';
import Flex from '../data/Flex';
import UIFlex, { copyFlex, IUIFlexProps } from './UIFlex';
import UIInput from './UIInput';
import './UIAutoComplete.scss';

export interface IUIAutoCompleteProps extends IUIFlexProps{
    name:string;
    data:{id:string, label:string}[];
}

export function UIAutoComplete($props:IUIAutoCompleteProps){

    const [inputValue, setInputValue] = useState("");
    
    let showOptions:boolean=false;

    let trimInputValue = inputValue.trim().toLowerCase();
    if(trimInputValue!==""){
        showOptions=true;
    }

    let inputValueWords:string[] = trimInputValue.split(" ");


    let dataMatching = $props.data.filter(($value)=>{
        let hasMatch:boolean=false;
        let dataValue = $value.label.toLowerCase();

        let matchingInputs = inputValueWords.filter(($word)=>{
            return dataValue.indexOf($word)!==-1;
        });

        hasMatch = matchingInputs.length===inputValueWords.length;

        return hasMatch;
    });

    return (
        <UIFlex className='autoComplete' flex={copyFlex({direction:Flex.COLUMN},$props.flex)}>
            <UIInput name={$props.name} onChange={($value, $name)=>{
                setInputValue($value+"");
            }} value={inputValue} />
            {showOptions && (
                <UIFlex className='autoCompleteResults' flex={{direction:Flex.COLUMN}}>
                    {dataMatching.length===0 && (
                        <div>No Matches</div>
                    )}
                    {dataMatching.map(($value)=>{
                        return <div key={$props.name+"-dditem-"+$value.id}>{$value.label}</div>;
                    })}
                </UIFlex>
            )}
        </UIFlex>
    );
}
